import { z } from "zod";

const productionStatuses = ["Idle", "InProgress", "Maintenance", "Unknown"] as const;

export const productionStatusSchema = z.enum(productionStatuses);

export type ProductionStatus = z.infer<typeof productionStatusSchema>;
